const sensitiveKey = /authorization|cookie|password|secret|token|api[-_]?key|credential/i;
export function redactContext(context) {
    return Object.fromEntries(Object.entries(context).map(([key, value]) => [
        key,
        sensitiveKey.test(key) ? '[REDACTED]' : value,
    ]));
}
export function createLogRecord(level, event, message, context = {}) {
    return {
        level,
        event,
        message,
        timestamp: new Date().toISOString(),
        context: redactContext(context),
    };
}
export function writeLog(record) {
    const output = JSON.stringify(record);
    if (record.level === 'error') {
        console.error(output);
        return;
    }
    if (record.level === 'warn') {
        console.warn(output);
        return;
    }
    console.info(output);
}
